import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-outage-popup-notification',
  templateUrl: './outage-popup-notification.component.html',
  styleUrls: ['./outage-popup-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OutagePopupNotificationComponent implements OnInit {
  data: any
  reason: string
  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.data = data.data
    })
  }

  closeModal(reason?: any): void {
    this.reason = reason
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.OUTAGE_NOTIFICATION,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
